import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgramacionService {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  //enviar orden al componente de Navbar para cargar imagen
  comunicacionIdaNavbar = new BehaviorSubject('');
  ordenNavbar = this.comunicacionIdaNavbar.asObservable();
  comunicacionVueltaNavbar = new BehaviorSubject('');
  ordenProg = this.comunicacionVueltaNavbar.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    if(this.authService.getIsAuth()){
      this.obtienInfo();
    }
  }

  obtienInfo(){
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  enviaNavbar(mensaje: string) {
    this.comunicacionIdaNavbar.next(mensaje);
  }

  enviaProg(mensaje: string) {
    this.comunicacionVueltaNavbar.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusProgramacion(productoId:any){
    this.obtienInfo();
    let datos: any = {productoId,	programacion: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusProgramacion(datos){
    console.log(datos);

    this.obtienInfo();
    // let datos: any = {fechaCertificar: anio,	programacion: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoProgramacion(datos){
    console.log(datos);

    this.obtienInfo();
    // let datos: any = {fechaCertificar: anio,	programacion: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }
  /// Servicios MEDIR
  getStatusProgramacionMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	programacion: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusProgramacionMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	programacion: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoProgramacionMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	programacion: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  guardaFechaProgramacionMedir(datos: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.shedule.guardaFechas + this.idEmpresa, datos);
  }

  getFechasProgramacionMedir(datos: any){
    this.obtienInfo();
    console.log("entró service programacion");
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.shedule.obtieneFechas + this.idEmpresa, datos);
  }

/// Servicios PulseCheck
getStatusProgramacionPulse(anio: any){
  this.obtienInfo();
  let datos: any = {productoId: anio,	programacion: 1};
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getStatusPart + this.idEmpresa, datos);
}

  guardaStatusProgramacionPulse(anio: any){
    this.obtienInfo();
  let datos: any = {productoId: anio,	programacion: 3};
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
  }

  desbloquearPasoProgramacionPulse(anio: any){
    this.obtienInfo();
  let datos: any = {productoId: anio,	programacion: 2};
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
  }

  getFechasProgramacionPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getFecha + this.idEmpresa, datos);
  }
  guardaFechasProgramacionPulse(datos){
    this.obtienInfo();
    // let datos: any = {productoId: anio,numeroFecha,fecha};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.agregaFechas + this.idEmpresa, datos);
  }
  guardaFechaPulseRecordatorios(datos){
    this.obtienInfo();

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaRecordatoriosPulse + this.idEmpresa, datos);
  }
  getFechaPulseRecordatorios(datos){
    this.obtienInfo();

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getRecordatoriosPulseLanzamiento + this.idEmpresa, datos);
  }

  ///////////SERVICIOS FOCUS AREA
    guardaStatusProgramacionFocus(encuestaID: any){
      this.obtienInfo();
      let datos: any = {encuestaID,	programacion: 3};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
    }

    desbloquearPasoProgramacionFocus(encuestaID: any){
      this.obtienInfo();
      let datos: any = {encuestaID,	programacion: 2};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
    }

    getStatusProgramacionFocus(encuestaID: any){
      this.obtienInfo();
      let datos: any = {encuestaID,	programacion: 1};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getStatusPart + this.idEmpresa, datos);
    }

  getFechasLanzamientoFocus(){
  let datos={encuestaID:localStorage.getItem('encuestaID')}
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getFechasLanzamientoFocus + localStorage.getItem('encuestaID'), datos);
  }

  getFechasLanzamientoFocus_estatussurvey(enuestaId){
    let datos={encuestaID:enuestaId}
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getFechasLanzamientoFocus + enuestaId, datos);
    }

  guardaFechasFocus(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaFechasLanzamientoFocus + localStorage.getItem('encuestaID'), datos);
  }


  ///////// SERVICIOS PARA TEMPLATES DE CORREOS
  getIdiomasProd(fecha: backInter.getIdiomaFechas){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + this.idEmpresa, fecha);
  }
  getIdiomasProdMedir(fecha: backInter.getIdiomaFechas){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getIdiomasGuardados + this.idEmpresa, fecha);
  }
  getIdiomasProdPulse(fecha: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getIdiomasGuardados + this.idEmpresa, fecha);
  }
  getListaIdiomasFocus(){
    this.obtienInfo();
    let datos :any={empresaId:this.idEmpresa}
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getListaIdiomasFocus + localStorage.getItem('encuestaID'),datos);//id plantilla fecha certif
  }
  getTemplate(datos: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.getTemplate + this.idEmpresa, datos);
  }
  empresaTemplate(datos: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.empresaTemplate + this.idEmpresa, datos);
  }
  saveTemplate(datos: any){
    this.obtienInfo();
    datos.empresaId = this.idEmpresa;
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.saveTemplate, datos);
  }
  updateTemplate(datos: any){
    this.obtienInfo();
    datos.empresaId = this.idEmpresa;
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.updateTemplate, datos);
  }
  statusTemplate(datos: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.statusTemplate + this.idEmpresa, datos);
  }
  getStatusEditorEmp(idProducto: string){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.templateCorreo.getStatusEditor + this.idEmpresa + "/" + idProducto);
  }

  //ODS
  updateTemplateValido(datos: any, idEmpresa: string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.updateTemplateValido + idEmpresa, datos);
  }
  empresaTemplateODS(datos: any, idEmpresa: string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.empresaTemplate + idEmpresa, datos);
  }
  updateTemplateODS(datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.updateTemplate, datos);
  }
  statusTemplateODS(idEmpresa: string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.statusTemplate + idEmpresa, {});
  }
  getStatusEditor(idEmpresa: string, idProducto: string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.templateCorreo.getStatusEditor + idEmpresa + "/" + idProducto);
  }
  setStatusEditor(idEmpresa: string, datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.setStatusEditor + idEmpresa, datos);
  }
  getCierreActivo(idEmpresa: string, idProducto: string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.templateCorreo.getCierreActivo + idEmpresa + "/" + idProducto);
  }
  setCierreActivo(idEmpresa: string, datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.setCierreActivo + idEmpresa, datos);
  }

  ////// Banderas de status
  setFlagsConfig(datos:any, idProducto:string, idEmpresa?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.flags.setCertificar + idEmpresa + "/" + idProducto, datos);
  }
  getFlagsConfig(idProducto:string, idEmpresa?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.flags.getCertificar + idEmpresa + "/" + idProducto);
  }
  setFlagsConfigMedir(datos:any, idProducto:string, idEmpresa?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.flags.setMedir + idEmpresa + "/" + idProducto, datos);
  }
  getFlagsConfigMedir(idProducto:string, idEmpresa?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.flags.getMedir + idEmpresa + "/" + idProducto);
  }
  setFlagsConfigPulseCheck(datos:any, idProducto:string, idEmpresa?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.flags.setPulseCheck + idEmpresa + "/" + idProducto, datos);
  }
  getFlagsConfigPulseCheck(idProducto:string, idEmpresa?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.flags.getPulseCheck + idEmpresa + "/" + idProducto);
  }
  setFlagsConfigFocusArea(datos:any, idProducto:string, idEmpresa?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.flags.setFocusArea + idEmpresa + "/" + idProducto, datos);
  }
  getFlagsConfigFocusArea(idProducto:string, idEmpresa?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.flags.getFocusArea + idEmpresa + "/" + idProducto);
  }

    validacionEncuestaRequeridaFocusArea(idEmpresa: string,idProducto: any,datos: any){
    console.log("valor: ", datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.validacionRequeridaFocusArea + idEmpresa + "/" + idProducto, datos);

  }
  getvalidacionEncuestaRequeridaFocusArea(idEmpresa: string, idProducto: any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.templateCorreo.getvalidacionRequeridaFocusArea + idEmpresa + "/" + idProducto);

  }

  getStatusBanderaProrroga(idEmpresa: string, idProducto: string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getBanderasProrroga + idEmpresa + "/" + idProducto);
  }

  getStatusPing(idEmpresa: string, idProducto: string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getBanderasPin + idEmpresa + "/" + idProducto);
  }

  actualizarPing(idEmpresa: string, idProducto: string,datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.setPin + idEmpresa + "/" + idProducto,datos);
  }
  actualizaStatusBanderaProrroga(idEmpresa: string, idProducto: string,datos:any){
    console.log(datos);

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizaBanderasProrroga + idEmpresa + "/" + idProducto,datos);
  }

 updateFechaCierreUsuarioEmpresa(datos:any){
   console.log(datos);

     return this.http.post(DATOS_API.url + DATOS_API.endpoints.fechaCierre.updateFechaCierreUsuario,datos);

 }


/////funciones que obtienen las fechas  de lanzamiento  de todos los productos
  getFechaLanzamientoStatusEncuestaPulsecheck(empresaId:any,data:any){
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getFecha+empresaId,data);
}

   surveyCheck(token:any){
     this.obtienInfo();
     return this.http.get(DATOS_API.url + DATOS_API.endpoints.surveyCheck + token);
   }

   /////funciones que obtienen las variables de configuracion
     getVariablesConfiguracionProducto(idEmpresa: string, idProducto: string){
     return this.http.get(DATOS_API.url + DATOS_API.endpoints.configuracionProducto.getBanderasConfiguracion+ idEmpresa + "/" + idProducto);
   }
     actualizaVariablesConfiguracionProducto(idEmpresa: string, idProducto: string, datos:any){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.configuracionProducto.actualizaBanderasConfiguracion+ idEmpresa + "/" + idProducto,datos);
   }


}
